export const apiConstants = {
  url: "/api/edgespacer"
};
